/**
 * Сколько особенностей отеля карточка показывает без раскрытия: в макете строка особенностей
 * делит ширину с тегом-троеточием и вмещает три тега, остальные уходят в шторку.
 */
export const SERP_CARD_VISIBLE_FEATURES = 3;

export const SERP_CARD_VIEW_RATIO = 0.75;
